const baseURL = `${process.env.VUE_APP_SERVER_URL}/ProgramaSaude`;
const atendimentoURL = `${process.env.VUE_APP_SERVER_URL}/Atendimento`;

export const ID_CLASSIFICA_CONVOCACAO = 10767;
export const ID_CLASSIFICA_RETORNO = 10768;

export async function ObterProtocolos({ vinculo }: { vinculo: string }) {
  return window.$axios
    .get({
      url: `${baseURL}/ObterProtocolos`,
      query: { vinculo }
    })
    .then(resp => resp.data);
}

export async function ObterTiposSolicitacao({ vinculo }: { vinculo: string }) {
  return window.$axios
    .get({
      url: `${baseURL}/ObterTiposSolicitacao`,
      query: { vinculo }
    })
    .then(resp => resp.data);
}

export async function DetalheProtocolo({ vinculo, protocolo }: { vinculo: string; protocolo: string }) {
  return window.$axios
    .get({
      url: `${baseURL}/DetalheProtocolo`,
      query: { vinculo, protocolo }
    })
    .then(resp => resp.data);
}

export async function UploadArquivo({ vinculo, formData }: { vinculo: string; formData: FormData }) {
  return window.$axios
    .post({
      url: `${atendimentoURL}/FileUpload`,
      query: { vinculo },
      data: formData,
      contentType: "multipart/form-data"
    })
    .then(resp => resp.data);
}

export async function NovaSolicitacao({ vinculo, data }: { vinculo: string; data: any }) {
  return window.$axios
    .post({
      url: `${baseURL}/NovaSolicitacao`,
      query: { vinculo },
      data
    })
    .then(resp => resp.data);
}

export async function RetornoPendencia({
  vinculo,
  protocolo,
  observacao,
  arquivos
}: {
  vinculo: string;
  protocolo: string;
  observacao?: string;
  arquivos?: File[];
}) {
  const data = new FormData();
  data.append("protocolo", protocolo);
  data.append("observacao", (observacao || "").slice(0, 350));
  (arquivos ?? []).forEach((file, index) => {
    const limiteMaximo = 20;
    const nomeCampo = `anexo${index + 1}`;

    if (index < limiteMaximo && file instanceof File) {
      data.append(nomeCampo, file);
    }
  });

  return window.$axios
    .post({
      url: `${baseURL}/RetornoPendencia`,
      query: { vinculo },
      data,
      contentType: "multipart/form-data"
    })
    .then(resp => resp.data);
}

export async function AvaliacaoAtendimento({
  vinculo,
  atendimento,
  tipo,
  etapa,
  obs,
  respostas,
  Nota
}: {
  vinculo: string;
  atendimento: string;
  tipo: number;
  etapa: string;
  obs: string;
  respostas: string[];
  Nota: number;
}) {
  return window.$axios.post({
    url: `${atendimentoURL}/AvaliacaoAtendimento`,
    query: {
      vinculo
    },
    data: {
      atendimento,
      tipo,
      etapa,
      obs,
      respostas,
      Nota
    }
  });
}

export async function ObterImagem({
  vinculo,
  documento,
  original = false
}: {
  vinculo: string;
  documento: number;
  original?: boolean;
}) {
  const key = `${vinculo};${documento};${original ? "T" : "F"}`;
  const chave = `${window.$jse.encrypt(key)}`;
  return window.$axios
    .get({
      url: `${baseURL}/ObterImagem`,
      query: { vinculo, chave }
    })
    .then(resp => resp.data);
}

export function ObterDocumento({ vinculo, protocolo }: { vinculo: string; protocolo: string }) {
  const key = `${vinculo};${protocolo}`;
  const chave = `${window.$jse.encrypt(key)}`;
  const queryString = new URLSearchParams({ vinculo, chave, tipo: ".pdf" }).toString();
  return `${baseURL}/ObterDocumento?${queryString}`;
}

export async function ValidacaoAtendimento({
  vinculo,
  protocolo,
  data
}: {
  vinculo: string;
  protocolo: string;
  data: any;
}) {
  return window.$axios
    .post({
      url: `${atendimentoURL}/ValidacaoAtendimento`,
      query: { vinculo, protocolo },
      data
    })
    .then(resp => resp.data);
}
